import React from "react";
import ReactDOM from "react-dom";

import { CookiesProvider } from "react-cookie";
import { I18nextProvider } from "react-i18next";
import { Router as Router, Link, Route, Switch } from "react-router-dom";

import Navigation from "./components/menus/navigation";   
import Footer from "./components/footer";
import Home from "./components/home";
import About from "./components/about";
import Game from "./components/TicTacToe";
import MedicationList from "./components/medication_list";
import TestPage from "./components/test_page";
import i18n from "./i18n";

import Authentication from "./components/user/authentication";
import Register from "./components/user/register";
import UserData from "./components/user/user-data";

import * as serviceWorker from "./serviceWorker";

import { createBrowserHistory } from "history";
import ExpandableTable from "./components/expandable_table";
import ExpandableTable2 from "./components/expandable_table2";
import VgSearch from "./components/video-games/vg_search";
import MealSearch from "./components/meals/meal_search"; 

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL
});

//ReactDOM.render(<Game />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

class Root extends React.Component {
  constructor(props) {
    super(props);

    var fontSize = "defaultFontSize";

    this.state = {
      fontSize: fontSize
    };

    this.updateNavigation = this.updateNavigation.bind(this);
    this.updateFontSize = this.updateFontSize.bind(this);
  }

  // This is called whenever the authentication state of a user is changed by a component
  updateNavigation() {
    this.nav.updateNavigation();
  }

  updateFontSize(fontSize) {
    this.getState().fontSize = fontSize;
    this.setState(this.state);
  }

  render() {
    return (
      <div className={this.state.fontSize}>
        <Navigation
          {...this.props}
          ref={component => {
            this.nav = component;
          }}
        />

        <Switch>
          {/* Information sites */}
          <Route path="/about" component={About} />
          <Route path="/tictactoe" component={Game} />
          <Route path="/vgsearch" component={VgSearch} />
          <Route path="/mealsearch" component={MealSearch} />
          <Route path="/medicationlist" component={MedicationList} />
          <Route path="/testpage" component={TestPage} />
          <Route path="/expandabletable" component={ExpandableTable} />
          <Route path="/expandabletable2" component={ExpandableTable2} />

          <Route path="/user/register" component={Register} />
          <Route path="/user/data" component={UserData} />
          <Route
            path="/user/login"
            render={props => (
              <Authentication
                {...props}
                updateNavigation={this.updateNavigation}
              />
            )}
          />

          {/* Default route */}
          <Route path="/" component={Home} />
        </Switch>

        <Footer />
      </div>
    );
  }
}

ReactDOM.render(
  <CookiesProvider>
    <I18nextProvider i18n={i18n}>
      <Router history={history}>
        <Root />
      </Router>
    </I18nextProvider>
  </CookiesProvider>,
  document.getElementById("root")
);
